import React, { Component } from 'react';
import ErrorPhoto from '~/Assets/Error.png'
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <img src={ErrorPhoto} style={{ backgroundSize:'cover', display:'block', margin:'0px auto', width:"120vh", outline:"none"}}/>
        }

        return this.props.children;
    }
}
export default ErrorBoundary